export { default as CenteredSingleColumn } from './CenteredSingleColumn';
export type { Props } from './CenteredSingleColumn';
